import { request, AUTH_HEADER } from '../utils/Api';

export function fetchStartupData() {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'startup' }).then((response) => {
        if(response.status === 200) {
          // Home data
          if(response.data.home.posts) {
            dispatch({
              type: "ADD_PAGE_CONTENT",
              page: 'home',
              payload: response.data.home.posts,
              max_num_pages: response.data.home.max_num_pages,
            });
          }

          // Music data
          if(response.data.music.posts) {
            dispatch({
              type: "ADD_PAGE_CONTENT",
              page: 'music',
              payload: response.data.music.posts,
              max_num_pages: response.data.music.max_num_pages,
            });
          }

          // Featured data
          if(response.data.featured.posts) {
            dispatch({
              type: "ADD_PAGE_CONTENT",
              page: 'featured',
              payload: response.data.featured.posts,
              max_num_pages: response.data.featured.max_num_pages,
            });
          }

          // Interviews data
          if(response.data.interviews.posts) {
            dispatch({
              type: "ADD_PAGE_CONTENT",
              page: 'interviews',
              payload: response.data.interviews.posts,
              max_num_pages: response.data.interviews.max_num_pages,
            });
          }

          // Featured data
          if(response.data.carousel) {
            dispatch({
              type: "UPDATE_HOMEPAGE_CAROUSEL",
              payload: response.data.carousel.posts,
            });
          }

          if(response.data.ads) {
            dispatch({
              type: "UPDATE_ADS",
              payload: response.data.ads,
            });
          }

          dispatch({
            type: "SET_LOADED",
            payload: true
          });
        }

        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function fetchHomePosts(page = 1) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'home', 'pagination': page }).then((response) => {
        if(response.status === 200) {
          dispatch({
            type: "ADD_PAGE_CONTENT",
            page: 'home',
            payload: response.data.posts,
            page_number: page,
          });
        }

        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function fetchMusicPosts(page = 1) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'music', 'pagination': page }).then((response) => {
        if(response.status === 200) {
          dispatch({
            type: "ADD_PAGE_CONTENT",
            page: 'music',
            payload: response.data.posts,
            page_number: page,
          });
        }

        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function fetchInterviewsPosts(page = 1) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'interviews', 'pagination': page }).then((response) => {
        if(response.status === 200) {
          dispatch({
            type: "ADD_PAGE_CONTENT",
            page: 'interviews',
            payload: response.data.posts,
            page_number: page,
          });
        }

        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function fetchFeaturedPosts(page = 1) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'featured', 'pagination': page }).then((response) => {
        if(response.status === 200) {
          dispatch({
            type: "ADD_PAGE_CONTENT",
            page: 'featured',
            payload: response.data.posts,
            page_number: page,
          });
        }

        resolve(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function fetchArticleBySlug(slug) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('', 'GET', { 'endpoint': 'article', 'slug': slug }).then((response) => {
        if(response.status === 200) {
          // Home data
          if(response.data && response.data.posts && response.data.posts.length) {
            resolve(response);
          }
        }

        reject(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function submitContactForm(data) {
  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('contact', 'POST', data).then((response) => {
        if(response.status === 200) {
          resolve(response);
        }

        reject(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}

export function subscribeToNewsletter(state) {
  let interests = [];

  let data = {
    "email": state.email,
  };

  if(state.hiphop) {
    interests = [].concat(interests, 'Hip Hop');
  }

  if(state.indie) {
    interests = [].concat(interests, 'Indie');
  }

  if(state.pop) {
    interests = [].concat(interests, 'Pop');
  }

  if(state.electronic) {
    interests = [].concat(interests, 'Electronic');
  }

  data.interests = interests.join();

  return dispatch => {
    // Request data for initial state (startup endpoint)
    return new Promise((resolve, reject) => {
      request('newsletter', 'POST', data).then((response) => {
        if(response.status === 200) {
          resolve(response);
        }

        dispatch({
          type: 'SUBSCRIBED',
          payload: true,
        });

        reject(response);
      }, (error) => {
        reject(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/content.js